import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-omgevingswet',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconOmgevingswet {

  render() {
    return (
      <svg viewBox="0 0 35.98 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M16.99 10.99c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3M0 27.01l8.94 8.96H9v-8.99H0zm35.79 2.8-.17.22c-.34.44-.97.51-1.41.17l-1.23-1.06v5.87c0 .55-.45 1-1 1h-10c-.55 0-1-.45-1-1v-5.87L19.7 30.2a.993.993 0 0 1-1.4-.21l-.12-.16a.996.996 0 0 1 .22-1.4l8.01-5.96a.99.99 0 0 1 1.18 0l3.38 2.46v-.89c.02-.55.46-.99 1.01-.99s1 .45 1 1v2.33l2.6 2c.46.33.55.98.2 1.43Zm-6.8.2c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1zm-10 4.99v.96h-8v-9.08c0-1.06-.86-1.91-1.91-1.91H0v-23C0 .88.88 0 1.97 0h24.04c1.09 0 1.97.88 1.97 1.97v18.47a2.977 2.977 0 0 0-2.75.41l-8.02 5.97c-.63.46-1.06 1.16-1.18 1.95-.12.79.07 1.58.54 2.23l.12.16c.54.74 1.39 1.19 2.3 1.22zM14.8 21.93c1.42-1.93 4.31-6.13 5.02-9.53.03-.14.17-1.13.17-1.41 0-3.31-2.69-5.99-6-5.99s-6 2.69-6 5.99c0 .28.14 1.27.17 1.41.71 3.39 3.59 7.6 5.02 9.53.4.54 1.21.54 1.61 0Z"/>
</svg>

    );
  }
}
